if (!customElements.get('collection-show-more')) {
  customElements.define(
    'collection-show-more',
    class CollectionShowMore extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('.js-collection-show-more__button');
        if (!button) return;
        button.addEventListener('click', () => {
          this.classList.add('collection-list--expanded');
          button.setAttribute('aria-expanded', 'true');
          button.remove();
        });
      }
    }
  );
}
